import Style from './styles.module.scss';
import { FormTextComponent } from 'src/features/generalForms/builder/types/Text';
import { isNullOrEmpty } from 'src/helpers/string-helper';
import { useAnswerRowConditional } from 'src/features/generalForms/answerPreview/hooks/useAnswerRowConditional';

export const TextBlock: FormTextComponent = ({ text, isHiddenOnOverview }) => {
  const { visible } = useAnswerRowConditional();
  if (isHiddenOnOverview || !visible || isNullOrEmpty(text)) {
    return <></>;
  }

  return <div className={Style.textBlock}>{text}</div>;
};
